import { CreditCard } from "../data/shared/CreditCard";
import { CreditCardData } from "data/shared/CreditCardData";
import { CardButton } from "./design-system/CardButton";
import { useState } from "react";

const TravelCardIds = [
  CreditCard.THE_PLATINUM_CARD,
  CreditCard.CHASE_SAPPHIRE_PREFERRED_CREDIT_CARD,
  CreditCard.VENTURE_X_REWARDS,
] as const;

const CashbackCardIds = [
  CreditCard.CITI_DOUBLE_CASH_CARD,
  CreditCard.BLUE_CASH_EVERYDAY_CARD,
  CreditCard.CHASE_FREEDOM_UNLIMITED_CREDIT_CARD
] as const;

const PopularCardIds = [
  CreditCard.CHASE_FREEDOM_UNLIMITED_CREDIT_CARD,
  CreditCard.AMERICAN_EXPRESS_GOLD_CARD,
  CreditCard.CITI_DOUBLE_CASH_CARD,
] as const;

const BuildingCreditCardIds = [
  CreditCard.CHASE_FREEDOM_RISE_CREDIT_CARD,
  CreditCard.DISCOVER_IT_SECURED_CREDIT_CARD,
  CreditCard.CITI_DIAMOND_PREFERRED_CREDIT_CARD,
] as const;

enum RecommendedCardIdType {
  TRAVEL = 'travel',
  CASHBACK = 'cashback',
  POPULAR = 'popular',
  BUILDING_CREDIT = 'building_credit',
}

const RecommendedCardIdTypeToIds = {
  [RecommendedCardIdType.TRAVEL]: TravelCardIds,
  [RecommendedCardIdType.CASHBACK]: CashbackCardIds,
  [RecommendedCardIdType.POPULAR]: PopularCardIds,
  [RecommendedCardIdType.BUILDING_CREDIT]: BuildingCreditCardIds,
};

const RecommendedCardIdTypeToLabel = {
  [RecommendedCardIdType.POPULAR]: 'Popular',
  [RecommendedCardIdType.TRAVEL]: 'Travel',
  [RecommendedCardIdType.CASHBACK]: 'Cashback',
  [RecommendedCardIdType.BUILDING_CREDIT]: 'Building Credit',
};

export const PopularCards = ({
  onAddCard,
  onRemoveCard,
  selectedCards,
  showTabs = true,
}: {
  onAddCard: (card: CreditCard) => void;
  onRemoveCard: (card: CreditCard) => void;
  selectedCards: CreditCard[];
  showTabs?: boolean;
}) => {
  const [recommendedCardType, setRecommendedCardType] = useState<RecommendedCardIdType>(
    !showTabs ? RecommendedCardIdType.POPULAR : RecommendedCardIdType.TRAVEL
  );

  return (
    <div style={{ margin: '10px 0' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ margin: '10px 0'}}>
          {showTabs && <p style={{ display: 'inline-block', marginRight: 10 }}>Recommended cards for: </p>}
          {showTabs && Object.values(RecommendedCardIdType).map((cardType) => {
            return (
              <button
                onClick={() => setRecommendedCardType(cardType)}
                style={{
                  margin: '0 5px',
                  ...(cardType === recommendedCardType
                    ? {
                        backgroundColor: '#4DA9E6',
                        color: 'white',
                      }
                    : {}),
                }}
              >
                {RecommendedCardIdTypeToLabel[cardType]}
              </button>
            );
          })}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 10,
            margin: 'auto',
            justifyContent: 'center',
          }}
        >
          {RecommendedCardIdTypeToIds[recommendedCardType].map((cardId) => {
            return (
              <div
                style={{ opacity: selectedCards.includes(cardId) ? 1 : 0.5, position: 'relative' }}
              >
                {selectedCards.includes(cardId) && (
                  <div style={{ position: 'absolute', top: 10, left: 10 }} >
                    ✅
                  </div>
                )}
                <CardButton
                  cardData={CreditCardData[cardId]}
                  onClick={() =>
                    selectedCards.includes(cardId)
                      ? onRemoveCard(cardId)
                      : onAddCard(cardId)
                  }
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}; 